import { theme } from '@prophecy/theme';
import { Button, Stack } from '@prophecy/ui-v3';
import { Alert, AlertProps } from '@prophecy/ui-v3/Alert';
import { Text } from '@prophecy/ui-v3/Typography';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { USAGE_AND_BILLING_PAGE } from '../constants';
import { useProfessionalEditionCreditsContext } from './useProfessionalEditionCreditsContext';

export const DowngradedToStarterBanner = (restProps: AlertProps) => {
  const navigate = useNavigate();
  const {
    customerBalance: { outstandingBalance }
  } = useProfessionalEditionCreditsContext();
  if (!outstandingBalance) return null;

  return (
    <Alert variant='gray' showIcon={false} banner={true} {...restProps}>
      <Stack direction='horizontal' width='100%' alignY='center'>
        <Stack grow='1' direction='horizontal' align='space-between' alignY='center'>
          <Text level='sm13' tone={theme.colors.gray700} weight={theme.fontWeight.medium}>
            Your team has been downgraded to the Starter plan due to payment failure. Please upgrade to continue.
          </Text>
          {
            <StyledButton
              variant='primary'
              size='s'
              data-test-id='downgraded-to-starter-banner-button'
              onClick={() => navigate(USAGE_AND_BILLING_PAGE)}>
              Upgrade Now
            </StyledButton>
          }
        </Stack>
      </Stack>
    </Alert>
  );
};

const StyledButton = styled(Button)`
  white-space: nowrap;
` as unknown as typeof Button;
export const StyledDowngradedToStarterBanner = styled(DowngradedToStarterBanner)`
  padding: ${theme.spaces.x12} ${theme.spaces.x24};
  align-items: center;
  background-color: ${theme.colors.grayBlue25};
  border-top: 1px solid ${theme.colors.gray200};
  color: ${theme.colors.gray800};
  font-weight: ${theme.fontWeight.medium};
  height: 3.75rem;
`;
